<div class="logo" routerLink="/" [class.running]="loading$ | async">
  <div class="inter"></div>
  <div class="middle"></div>
  <div class="outer"></div>
  <div class="meta-title">
    <div class="app-title">{{ config.config.appTitle }}</div>
    <div class="app-confidential">For internal use only - no forwarding</div>
  </div>
</div>
<div class="page-title">{{ 'menu.'+data.title | translate }}</div>
<ul class="links">
  @for (link of reports|async; track link) {
    <li [routerLink]="link.link" routerLinkActive="active">{{ 'menu.'+link.text | translate }}</li>
  }
  <li routerLink="/about" routerLinkActive="active">{{ 'menu.about' | translate }}</li>
  <li routerLink="/help" routerLinkActive="active">{{ 'menu.help' | translate }}</li>
  <app-theme-switcher></app-theme-switcher>
</ul>
<div class="menu-icon" [ngClass]="{'active': data.sidenavOpened | async}" (click)="openSidenav()">
  <div class="icon">
    <div class="wrapper">
      <div class="top"></div>
      <div class="middle"></div>
      <div class="bottom"></div>
    </div>
  </div>
</div>